export default __webpack_public_path__ + "static/media/bg-stats-tiles-particles-3.be1f38b9.png";